
import ResizeHelper from './includes/_ResizeHelper.js'
import ScrollHelper from './includes/_ScrollHelper.js'
import Intersection from './includes/_Intersection.js'  
import Device from './includes/_Device.js'
import { remap, clamp } from './includes/_Utility.js'
import CONSTS from './_const.js'

const isSP = window.matchMedia(`(max-width: ${CONSTS.BREAK_POINT}px)`)

function vw(px) {
  const viewport = isSP.matches ? 375 : 1920
  return px/viewport*100
}

class TieUpsKV {
  constructor(el) {
    this.id = el
    this.$el = document.querySelector(el)
    this.$body = document.body

    if(this.$el) {
      this.$movie = this.$el.querySelector('.js-tieupskv--movie')
      this.$video = this.$el.querySelector('.js-tieupskv--video')
      this.$text = this.$el.querySelector('.js-tieupskv--text')
      this.$fade = document.querySelectorAll('.js-fadewithkv')
  
      this.setting = {}
      this.option = {
        "pc": {
          margin: 132 * 2,
          radius: 768,
          radius_origin: 768,
          pow: 1.5
        },
        "sp": {
          margin: -173 * 2,
          radius: 368,
          radius_origin: 368,
          pow: 3
        }
      }
      this.viewbox = {}
      if(this.$el) {
        this.resize()
        this.bind()
        this.intersection()
        this.style()
      }
    }

  }
  resize() {
    this.setting = isSP.matches ? this.option.sp : this.option.pc
    this.viewbox = {
      width: window.innerWidth,
      height: window.innerHeight,
      top: this.$text.getBoundingClientRect().height
    }
    this.setting.radius = isSP.matches ? this.setting.radius_origin : Math.min(this.setting.radius_origin, this.viewbox.width / 2)
    this.style()
  }
  intersection() {
    new Intersection(this.id, entries => {
      entries.forEach(entry => {
        document.querySelector('body').classList.toggle('is-kv', entry.isIntersecting)
      })
    }, {
      root: null,
      rootMargin: "0% 0px 0px 0px",
      threshold: 0
    })
  
  
  }
  bind() {
    const resizeHelper = new ResizeHelper(this.resize.bind(this), 1000 / 10)
    resizeHelper.init()
    new ScrollHelper(this.style.bind(this), 1000 / 30)


    this.$video.addEventListener('canplaythrough', () => {
      this.$movie.classList.add('--canplaythrough');
    })
    this.$video.play()
    this.$video.muted = true;
    this.$video.playsinline = true;
  }
  style() {
    const scrolltop = document.documentElement.scrollTop
    const norm = clamp(remap(scrolltop, 0, this.viewbox.top, 0, 1), 0, 1)
    const radius = Math.min(this.setting.radius, this.setting.radius - (this.setting.radius * Math.pow(norm, this.setting.pow)))

    if(isSP.matches) {
      const r = remap(Math.pow(norm, 10), 0, 1, 184/2, 11400)
      Object.assign(this.$movie.style, {
        'clip-path': `circle(${r}vw at calc(50%) ${r}vw)`
      })
    } else {
      const r = remap(Math.pow(norm, 6.4), 0, 1, 86.25/2, 1000)
      Object.assign(this.$movie.style, {
        'clip-path': `circle(${r}vw at calc(50%) ${r}vw)`
      })
    }
    Object.assign(this.$text.style, {
      opacity: Math.pow(1 - norm, 4)
    })
    this.$fade.forEach(el => {
      Object.assign(el.style, {
        opacity: Math.pow(1 - norm, 4),
        pointerEvents: norm === 1 ? 'none' : 'auto'
      })
    })
  }
}

export default TieUpsKV;
